var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"editorElem",staticClass:"wang-editor-wrapper"})
}
var staticRenderFns = []

export { render, staticRenderFns }